// function to set the preview mode
export function setFontSyncMode(mode) {
  sessionStorage.setItem('mrIsFontSyncMode', mode);
}

// function to get the font-sync mode
export function getFontSyncMode() {
  return sessionStorage.getItem('mrIsFontSyncMode');
}

export function isFontSyncMode() {
  if (getFontSyncMode() === 'true') {
    return true;
  }
  const urlSearchParams = new URLSearchParams(window.location.search);
  const fontSyncMode = urlSearchParams.get('mrcafsm');
  if (fontSyncMode) {
    return true;
  }

  return false;
}
